import React from 'react';
import {
  Button,
  Grid,
  Card,
  CardMedia,
  CardActions,
  IconButton,
  CardContent,
  TablePagination,
} from '@mui/material';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useState } from 'react';
import DeleteModal from '../../Common/DeleteModal';
import { deleteRequest } from '../interceptor/interceptor';
import { DELETE_IMAGE } from '../../apiConst';
import { toast } from 'react-toastify';

const ImageGallery = ({
  tableRowsData,
  getListData,
  rowsPerPage,
  setRowsPerPage,
  totalCount,
  page,
  setPage,
}) => {
  const [modal, setModal] = useState(false);
  const [dataId, setDataId] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await getListData(Number(newPage + 1), rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    getListData(1, parseInt(event.target.value));
  };
  const onDelete = (key) => {
    setIsLoading(true);
    deleteRequest(`${DELETE_IMAGE}${key}`)
      .then((res) => {
        setModal(false);
        setIsLoading(false);
        toast.success('Deleted Successfully');
        getListData();
      })
      .catch((error) => {
        setModal(false);
        console.log('error', error);
        setIsLoading(false);
      });
  };

  return (
    <>
      {/* <DeleteModal
        dataId={dataId}
        firstButtonText={"Cancel"}
        secondButtonText={"Delete"}
        heading={"Confirm Delete"}
        body={<p>Do you want to remove the Image?</p>}
        modal={modal}
        pressSecondButton={(id) => onDelete(id)}
        pressFirstButton={() => setModal(false)}
        pressCloseButton={() => setModal(false)}
      /> */}
      <div className="m-2 shadow-lg bg-white rounded-md p-2">
        <div className="flex items-center mb-4 text-2xl font-bold text-gray-800">
          Images
        </div>
        <Grid container spacing={2} justifyContent="start" className="mb-2">
          {tableRowsData && tableRowsData.length > 0 ? (
            tableRowsData.map((data, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card className="relative shadow-md rounded-lg overflow-hidden flex flex-col">
                  <CardMedia
                    component="img"
                    height="200"
                    image={data.url}
                    alt={data.key}
                    className="object-cover w-full h-[200px]"
                  />
                  <IconButton
                    color="error"
                    className="absolute top-2 right-2"
                    onClick={() => onDelete(data?.key)}
                  >
                    <FaTrash />
                  </IconButton>
                </Card>
              </Grid>
            ))
          ) : (
            <p className="text-center p-4 w-full">No images available</p>
          )}
        </Grid>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={'Entries per page: '}
          labelDisplayedRows={({ from, to, count }) =>
            `Showing ${from}-${to} of ${count} entries`
          }
        />
      </div>
    </>
  );
};

export default ImageGallery;
